import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { ChevronRight } from "lucide-react";
import { cn } from "./utils";
import { useState } from "react";

interface CollapsibleProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  defaultOpen?: boolean;
}

export function Collapsible({ title, children, className, defaultOpen = false }: CollapsibleProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <CollapsiblePrimitive.Root open={open} onOpenChange={setOpen} className={cn("border-4 border-black/30 mt-6", className)}>
      <CollapsiblePrimitive.Trigger className="flex w-full items-center gap-2 p-4 text-left font-black text-sm text-zinc-700 hover:bg-black/5 transition-colors">
        <ChevronRight className={cn("h-4 w-4 transition-transform", open && "rotate-90")} strokeWidth={3} />
        {title}
      </CollapsiblePrimitive.Trigger>
      <CollapsiblePrimitive.Content className="px-4 pb-4">
        {children}
      </CollapsiblePrimitive.Content>
    </CollapsiblePrimitive.Root>
  );
}
